import React from 'react'

import styled from 'styled-components'

import SaveIcon from 'src/Assets/Svg/campaignDetails/save.svg?react'
import UnsaveIcon from 'src/Assets/Svg/campaignDetails/unsave.svg?react'
import {
  SquareButton,
  SquareButtonProps,
} from 'src/Components/Buttons/SquareButton'
import { variables } from 'src/Styled/variables'

const StyledButton = styled(SquareButton)`
  padding: 0 12px;
  flex-grow: 0;
`

const ChildrenWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 8px;
`

const Text = styled.span`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
`

export type SaveButtonProps = Pick<
  SquareButtonProps,
  'loading' | 'onClick' | 'disabled'
> & {
  isSaved?: boolean
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  loading,
  onClick,
  disabled,
  isSaved = false,
}) => (
  <StyledButton loading={loading} disabled={disabled} onClick={onClick}>
    <ChildrenWrapper>
      {isSaved ? <UnsaveIcon /> : <SaveIcon />}
      <Text>{isSaved ? 'Curator saved' : 'Save curator'}</Text>
    </ChildrenWrapper>
  </StyledButton>
)
